import React, { useState } from 'react'

// components
import {
  CAccordion,
  CAccordionHeader,
  CAccordionBody,
  CAccordionItem,
} from '@coreui/react-pro'
import AppFirstForm from './AppFirstForm'
import AppSecondForm from './AppSecondForm'

const AppForm = ({
  editPage,
  values,
  handleChange,
  errors,
  couponTypeOptions,
  openCouponPeriod,
  setOpenCouponPeriod,
  handleApplyCouponTo,
  handleRemoveImage,
  handleFileInput,
  handleFileOnDrop,
  handleStartDateRange,
  handleEndDateRange,
  handleMultiSelect,
  handleShippingMethod,
  handleVoucherValue,
  handleSelectCouponType,
  setOpenFilePreview,
  couponDetails
}) => {

  return (
    <CAccordion activeItemKey={1}>
      <CAccordionItem itemKey={1}>
        <CAccordionHeader>
          <b>Step 1: </b> &nbsp; Basic Coupon Information
        </CAccordionHeader>
        <CAccordionBody>
          <AppFirstForm
            editPage={editPage}
            values={values}
            handleChange={handleChange}
            errors={errors}
            couponTypeOptions={couponTypeOptions}
            openCouponPeriod={openCouponPeriod}
            setOpenCouponPeriod={setOpenCouponPeriod}
            handleRemoveImage={handleRemoveImage}
            handleChangeImage={handleFileInput}
            handleFileInput={handleFileInput}
            handleFileOnDrop={handleFileOnDrop}
            handleStartDateRange={handleStartDateRange}
            handleEndDateRange={handleEndDateRange}
            handleShippingMethod={handleShippingMethod}
            handleVoucherValue={handleVoucherValue}
            handleSelectCouponType={handleSelectCouponType}
            setOpenFilePreview={setOpenFilePreview}
            couponDetails={couponDetails}
          />
        </CAccordionBody>
      </CAccordionItem>
      <CAccordionItem itemKey={2} hidden={values.coupon_type === 'free-shipping'}>
        <CAccordionHeader>
          <span className={errors?.apply_coupon_to ? "text-danger" : ""}><b>Step 2: </b> &nbsp; Coupon Eligibility</span>
        </CAccordionHeader>
        <CAccordionBody>
          <AppSecondForm
            editPage={editPage}
            values={values}
            handleChange={handleChange}
            handleMultiSelect={handleMultiSelect}
            errors={errors}
            handleApplyCouponTo={handleApplyCouponTo}
          />
        </CAccordionBody>
      </CAccordionItem>
    </CAccordion>
  )
}

export default AppForm
